import { shouldAttachOverflowTooltip } from './multiselect-helper.js';
import { hasSlot } from '../../utils/utils.js';
import PendoIcon from '../icon/pendo-icon.vue.js';
import PendoTooltip from '../../directives/tooltip/pendo-tooltip.js';

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }
    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
var script = {
  components: {
    PendoIcon
  },
  directives: {
    PendoTooltip
  },
  props: {
    disabled: {
      type: Boolean
    },
    getOptionLabel: {
      type: Function
    },
    inputValue: {
      type: String
    },
    isOpen: {
      type: Boolean
    },
    isPlaceholderVisible: {
      type: Boolean
    },
    isSelectedLabelVisible: {
      type: Boolean
    },
    limit: {
      type: Number
    },
    limitText: {
      type: Function
    },
    loading: {
      type: Boolean
    },
    model: {
      type: Array
    },
    placeholder: {
      type: [String, Number]
    },
    removeSelection: {
      type: Function
    },
    selectedLabel: {
      type: [String, Number]
    },
    selectedValue: {
      type: [Object, Number, String, Array]
    },
    selectedValuePointer: {
      type: Number
    },
    shouldAnimateSearchEnterExit: {
      type: Boolean
    },
    showSelectedValueTags: {
      type: Boolean
    },
    toggleMenu: {
      type: Function
    },
    visibleSelectedValues: {
      type: Array
    }
  },
  data() {
    return {
      selectedLabelOverflowTooltipContent: null
    };
  },
  computed: {
    labelTransition() {
      if (this.shouldAnimateSearchEnterExit) {
        return 'pendo-multiselect-label-slide';
      }
      return '';
    }
  },
  watch: {
    selectedLabel: _async(function () {
      const _this = this;
      return _await(_this.$nextTick(), function () {
        _this.checkForSelectedLabelOverflow();
      });
    })
  },
  methods: {
    beforeLeave(el) {
      el.style.display = 'none';
    },
    checkForSelectedLabelOverflow() {
      this.selectedLabelOverflowTooltipContent = null;
      if (this.isSelectedLabelVisible) {
        const hasCustomSelectedLabelSlotContent = hasSlot(this, 'selectedLabel', {
          option: this.selectedValue,
          selectedLabel: this.selectedLabel
        });
        if (hasCustomSelectedLabelSlotContent) {
          return;
        }
        const showOverflowTooltip = shouldAttachOverflowTooltip(this.selectedLabel, this.$refs.selectedLabel);
        if (showOverflowTooltip) {
          this.selectedLabelOverflowTooltipContent = this.selectedLabel;
        }
      }
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-multiselect-value.vue2.js.map
